/**
 * These are base url for api
 * API include gateway, data, log and auth
 */

export const PERMISSIONS = `/v1/auth/permissions`;
export const ROLES = `/v1/auth/roles`;
export const PROCESSORS = `/v1/data/processors`;
export const TRANSACTION_CHARGES = `/v1/data/transactionChargeConfigs`;
export const PROCESSING_SUMMARIES = `/v1/gateway/processing-summary`;
export const MERCHANT_BENEFICIARIES = `/v1/data/merchantBeneficiaries`;
export const MERCHANT_ACCOUNTS = `/v1/data/merchants`;
export const MERCHANT_API_TOKENS = `/v1/data/merchantDtls/merchant`;
export const MERCHANT_DETAILS = `/v1/data/merchantDtls`;
export const TRANSACTIONS = `/v1/transactions`;
export const USERS = `/v1/auth/users`;
export const TRANSACTION_SETTLEMENTS = `/v1/transactions/settlements`;
export const TRANSACTION_WITHDRAWALS = `/v1/transactions/withdrawals`;
export const TRANSACTION_DEPOSITS = `/v1/transactions/deposits`;
export const CURRENCY_AGGREGATED_BALANCE = `/v1/data/wallets/aggregated-balance`;
export const TRANSACTION_CHARGEBACKS = `/v1/transactions/charge-back`;
export const TRANSACTION_REFUNDS = `/v1/transactions/refunds`;
export const REVERSE_CURRENCY_TRANSACTION = `/v1/transactions/duplicate/reverse`;
export const COLLECTION_REFUND_BY_ADMIN = `/v1/collections/refund-by-admin`;
export const FDS_CARDS = `/v1/fds/cards`;
export const EVENTS = `/v1/logs/events`;
export const SETTLEMENT_REPORTS = `/v1/data/settlementReports`;
export const QUEUEMESSAGES = `/v1/logs/queue-messages`;
export const MIDS = `/v1/data/mids`;
export const DATA_TRAFFIC_WEBSITES = `/v1/data/traffic-websites`;
export const GATEWAY_TRANSACTIONS = `/v1/gateway/transactions`;
export const GATEWAY_CALLBACKS = `/v1/gateway/callbacks`;
export const GATEWAY_SUSPECIOUS_ACTIVITIES = `/v1/gateway/suspiciousActivities`;
